namespace RioERP.Products {
    export interface ProductFranchiseeShareImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class ProductFranchiseeShareImportForm extends Serenity.PrefixedContext {
        static formKey = 'Products.ProductFranchiseeShareImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductFranchiseeShareImportForm.init)  {
                ProductFranchiseeShareImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(ProductFranchiseeShareImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
